import { isUndefined, isNumber, get, reduce, isObject } from '@antv/util';
import { Options } from '../../types';
import { LEVEL, log } from '../../utils';
import { ABSOLUTE_FIELD, DIFF_FIELD, IS_TOTAL, Y_FIELD } from './constant';

/**
 * @desc æ°æ®å¤çå½æ°ï¼ç»ä¸å°æ°æ®å¤çæ[start, end]
 * @param data
 * @param xField
 * @param yField
 * @param totalLabel
 */
export function processData(
  data: Options['data'],
  xField: string,
  yField: string,
  newYField: string,
  total?: false | { label?: string }
) {
  const newData = [];
  reduce(
    data,
    (r, d) => {
      // æ ¡éªæ°æ®åæ³æ§
      log(LEVEL.WARN, isNumber(d[yField]), `${d[yField]} is not a valid number`);
      const value = isUndefined(d[yField]) ? null : d[yField];
      newData.push({ ...d, [newYField]: [r, r + value] });

      return r + value;
    },
    0
  );
  // å¦æéè¦å±ç¤ºæ»å
  if (newData.length && total) {
    const sum = get(newData, [[data.length - 1], newYField, [1]]);
    newData.push({
      [xField]: total.label,
      [yField]: sum,
      [newYField]: [0, sum],
    });
  }
  return newData;
}

/**
 * å¤çä¸º çå¸å¾ æ°æ®
 */
export function transformData(
  data: Options['data'],
  xField: string,
  yField: string,
  total?: false | { label?: string }
) {
  const processed = processData(data, xField, yField, Y_FIELD, total);
  return processed.map((d, dIdx) => {
    if (!isObject(d)) {
      return d;
    }
    return {
      ...d,
      [ABSOLUTE_FIELD]: d[Y_FIELD][1],
      [DIFF_FIELD]: d[Y_FIELD][1] - d[Y_FIELD][0],
      [IS_TOTAL]: dIdx === data.length,
    };
  });
}
